import React from "react";

const CLoader = () => {
    return (
        <div className="CLoader-wrapper">
            <div className="lds-facebook">
                <div></div>
                <div></div>
                <div></div>
            </div>
        </div>
    );
};

export default CLoader;
